export default __webpack_public_path__ + "static/halflings-00d0101eda6b49e89b2282c4c73f963b.webp";